import { Link } from "react-router-dom";
import { useApi } from "@/lib/useApi";
import { API } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { PageHeader, EmptyState, Stat } from "@/components/common";
import { BarChart3, Eye, Heart, MessageCircle, Newspaper, ExternalLink } from "lucide-react";
import { fDateTime } from "@/lib/format";

export default function Statistik() {
  const { t } = useLang();
  const { data } = useApi("/feed/mine/stats");
  const posts = data?.posts || [];
  const totals = data?.totals || { posts: 0, views: 0, reactions: 0, comments: 0 };

  return (
    <div className="mx-auto max-w-3xl">
      <PageHeader title={t("st_title")} icon={BarChart3} subtitle={t("st_sub")} />

      <div className="mb-6 grid grid-cols-2 gap-3 sm:grid-cols-4">
        <Stat label={t("st_total_posts")} value={totals.posts} icon={Newspaper} tone="accent" />
        <Stat label={t("st_views")} value={totals.views} icon={Eye} tone="ok" />
        <Stat label={t("st_reactions")} value={totals.reactions} icon={Heart} tone="warn" />
        <Stat label={t("st_comments")} value={totals.comments} icon={MessageCircle} />
      </div>

      {posts.length === 0 ? (
        <EmptyState icon={BarChart3} title={t("st_empty_title")} text={t("st_empty_text")} />
      ) : (
        <div className="space-y-3">
          {posts.map((p) => (
            <Card key={p.id} className="p-4" data-testid={`stat-post-${p.id}`}>
              <div className="flex flex-wrap items-center gap-2">
                <span className="font-medium">{p.title || (p.body || "").slice(0, 50) || "—"}</span>
                {p.video_path && <Badge variant="outline">video</Badge>}
                {p.image_path && <Badge variant="outline">bild</Badge>}
                <Link to={`/flode?post=${p.id}`} className="ml-auto inline-flex items-center gap-1 text-xs text-accent underline" data-testid={`stat-open-${p.id}`}>
                  <ExternalLink className="h-3.5 w-3.5" />{t("st_open_post")}
                </Link>
              </div>
              <div className="mt-2 flex flex-wrap gap-4 text-sm text-muted-foreground">
                <span className="flex items-center gap-1" data-testid={`stat-views-${p.id}`}><Eye className="h-4 w-4" />{p.views} {t("st_views")}</span>
                <span className="flex items-center gap-1" data-testid={`stat-reactions-${p.id}`}><Heart className="h-4 w-4" />{p.reactions} {t("st_reactions")}</span>
                <span className="flex items-center gap-1" data-testid={`stat-comments-${p.id}`}><MessageCircle className="h-4 w-4" />{p.comments} {t("st_comments")}</span>
                <span className="ml-auto text-xs">{fDateTime(p.created_at)}</span>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
